<template>
    <ContentOrLoading>
        <div v-if="event" :class="event?.experiencia ? 'single-event' : ''">
            <PageTitle
                title=""
                :style="'background-image: url(&quot;' + event?.imagen + '&quot;);'"
            />
            <section class="padding-vertical-content">
                <ContentOrLoading>
                    <div class="container" v-if="event">
                        <CabeceraClubs
                            v-if="event.equipo_local"
                            :event="event"
                        />
                        <CabeceraImagen
                            v-else
                            :event="event"
                        />
                        <div v-if="event?.preventa?.texto_registro_preventa">
                            <div v-html="textoSanitizado"></div>
                            <hr class="mb-2"/>
                        </div>
                        <template v-if="paso === 1">
                            <InfoRegistroPreventa v-if="!user" />
                            <FormRegistro
                                v-else
                                :event="event"
                                :loading="loading"
                                :validationErrors="validationErrors"
                                @terminado="(registro) => { solicitarRegistro(registro); }"
                            />
                        </template>
                        <RegistroRealizado :event="event" v-if="paso === 2" :esExperiencia="event?.experiencia"/>
                    </div>
                </ContentOrLoading>
            </section>
        </div>
    </ContentOrLoading>
</template>

<script setup>
    import { toRef, onMounted, computed } from 'vue';
    import DOMPurify  from 'dompurify';

    import PageTitle from '@/components/frontend/shared/PageTitle';
    import InfoRegistroPreventa from '@/components/frontend/events/registro-preventa/InfoRegistroPreventa';
    import FormRegistro from '@/components/frontend/events/registro-preventa/FormRegistro';
    import RegistroRealizado from '@/components/frontend/events/registro-preventa/RegistroRealizado';
    import CabeceraClubs from '@/components/frontend/events/show/CabeceraClubs';
    import CabeceraImagen from '@/components/frontend/events/show/CabeceraImagen';

    import { useRegistroPreventa } from '@/composables/front/events/preventa/useRegistroPreventa';

    const props = defineProps({
        event_id: {
            type: [String, Number],
            required: true
        },
        sesion_id: {
            type: [String, Number],
            required: true
        }
    });

    const eventoIdRef = toRef(props, 'event_id');
    const sesionIdRef = toRef(props, 'sesion_id');

    const textoSanitizado = computed(() =>
        event.value?.preventa?.texto_registro_preventa
            ? DOMPurify.sanitize(event.value.preventa.texto_registro_preventa)
            : '' );

    const {
        event,
        validationErrors,
        paso,
        loading,
        user,
        getEvent,
        solicitarRegistro
    } = useRegistroPreventa(eventoIdRef, sesionIdRef);


    onMounted(() => {
        getEvent();
    });
</script>
